export enum ActivityEventName {
    Config = 'config',
    Entry = 'entry',
    Loading = 'loading',
    EntryIntroView = 'entry_intro_view',
    EntryGameView = 'entry_game_view',
    FirstUserGesture = 'first_user_gesture', // 進入主遊戲內後, 使用者的第一次互動行為, (不含introView上的UI操作)
    FirstMeaningfulInteraction = 'first_meaningful_interaction', // 進入主遊戲內後, 使用者的第一次按鈕行為, (不含introView上的UI操作)
    Error = 'error',
    Close = 'close',
    CloseByUI = 'close_by_ui',
    CloseByError = 'close_by_error',
    CloseByBrowser = 'close_by_browser',
    RotatePortrait = 'rotate_portrait',
    RotateLandscape = 'rotate_landscape',
    PageHide = 'page_hide', // 最小化或切換分頁
    PageShow = 'page_show', // 分頁恢復顯示
    RunScene = 'run_scene', // 切換場景
    NetworkLatency = 'network_latency', // 網路延遲
    NetworkSpeedTest = 'network_speed_test', // 網路速度測試
}

export interface IBaseActivityEventRequestDataType {
    [pathName: string]: any;
}

export interface IActivityEventDataType {
    [ActivityEventName.Config]: ActivityConfigDataType;
    [ActivityEventName.Entry]: ActivityEntryDataType;
    [ActivityEventName.Loading]: ActivityLoadingDataType;
    [ActivityEventName.EntryIntroView]: ActivityEntryIntroViewDataType;
    [ActivityEventName.EntryGameView]: ActivityEntryGameViewDataType;
    [ActivityEventName.FirstUserGesture]: ActivityFirstUserGestureDataType;
    [ActivityEventName.FirstMeaningfulInteraction]: ActivityFirstUserGestureDataType;
    [ActivityEventName.Error]: ActivityErrorDataType;
    [ActivityEventName.Close]: ActivityCloseDataType;
    [ActivityEventName.CloseByUI]: ActivityCloseDataType;
    [ActivityEventName.CloseByError]: ActivityCloseDataType;
    [ActivityEventName.CloseByBrowser]: ActivityCloseDataType;
    [ActivityEventName.RotatePortrait]: ActivityRotateDataType;
    [ActivityEventName.RotateLandscape]: ActivityRotateDataType;
    [ActivityEventName.PageShow]: ActivityPageShowDataType;
    [ActivityEventName.PageHide]: ActivityPageHideDataType;
    [ActivityEventName.RunScene]: ActivityRunSceneDataType;
    [ActivityEventName.NetworkLatency]: ActivityNetworkLatencyDataType;
    [ActivityEventName.NetworkSpeedTest]: ActivityNetworkSpeedTestDataType;
}

export type ActivityConfigDataType = {
    token: string;
    gameID: string;
    host?: string;
    requireGeoPermission?: boolean;
};

export type ActivityEntryDataType = {
    GameVersion: string; // 前端遊戲版號
    GameLanguage: string; // 用戶使用的語系
    SupportWebP: boolean; // 用戶設備是否支持webp格式圖片
    SupportAVIF: boolean; // 用戶設備是否支持avif格式圖片
    ParentHref: string; // iframe 父視窗的url, 當跨域時只能拿到host
};

export type ActivityNetworkLatencyDataType = {
    latency: number; // 網路延遲時間，單位為毫秒
};

export type ActivityNetworkSpeedTestDataType = {
    speed: number; // 網路速度，單位為KB/s
};

export type ActivityLoadingDataType = {};

export type ActivityEntryIntroViewDataType = {};

export type ActivityEntryGameViewDataType = {};

export type ActivityFirstUserGestureDataType = {};

export type ActivityFirstMeaningfulInteractionDataType = {};

export type ActivityErrorDataType = {
    ErrorCode: number; // 後端/前端的錯誤代碼
    Message: string; // 實際錯誤訊息
    Stack: string; // 錯誤堆疊
    Native: string; // 原生錯誤訊息
    LocationOrigin: string; // 發生錯誤的網頁位置
};

export type ActivityCloseDataType = {
    ErrorCode?: number; // 後端/前端的錯誤代碼
};

export type ActivityRotateDataType = {};

export type ActivityPageShowDataType = {};

export type ActivityPageHideDataType = {};

export type ActivityRunSceneDataType = {
    scene: string;
    time: number;
};
